import { useEffect, useState } from "react"
import { FiChevronDown, FiChevronRight, FiVolume2, FiFile } from "react-icons/fi"
import { useApi } from "../../hooks/useApi"

const ListeningMaterials = ({ material_type }) => {
  const type = material_type.toLowerCase()
  const [materials, setMaterials] = useState([])
  const [page, setPage] = useState(1)
  const [expandedMaterialId, setExpandedMaterialId] = useState(null)

  const { fetchData, isLoading, error } = useApi()

  const itemsPerPage = 4
  const start = (page - 1) * itemsPerPage
  const finish = start + itemsPerPage

  const handlePageChange = (direction) => {
    if (direction === "previous") {
      setPage((prevPage) => Math.max(1, prevPage - 1))
    } else {
      setPage((prevPage) => Math.min(Math.ceil(materials.length / itemsPerPage), prevPage + 1))
    }
  }

  const handleBoxClick = (id) => {
    setExpandedMaterialId((prevId) => (prevId === id ? null : id))
  }

  useEffect(() => {
    const fetchMaterials = async () => {
      try {
        const data = await fetchData(`/materials/${type}`)
        setMaterials(data)
      } catch (err) {
        console.error("Error fetching materials:", err)
      }
    }
    fetchMaterials()
  }, [type, fetchData])

  const downloadFile = async (url, filename) => {
    try {
      const response = await fetch(url)
      const blob = await response.blob()
      const link = document.createElement("a")
      link.href = URL.createObjectURL(blob)
      link.download = filename
      link.click()
      URL.revokeObjectURL(link.href)
    } catch (error) {
      console.error("Error downloading the file:", error)
    }
  }

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error: {error.message}</div>
  }

  return (
    <div>
      <div className="material-box-container">
        {materials.slice(start, finish).map((material) => (
          <li key={material.activity_no} className="material-box" onClick={() => handleBoxClick(material.activity_no)}>
            <div className="material-listItem">
              {expandedMaterialId === material.activity_no ? <FiChevronDown size={40} /> : <FiChevronRight size={40} />}
              <span>Activity {material.activity_no}</span>
            </div>
            {expandedMaterialId === material.activity_no && (
              <div className="materials-drop">
                {(material_type === "Listening" || material_type === "Speaking") && (
                  <div className="material">
                    <FiVolume2 size={20} />
                    <span onClick={() => downloadFile(material.audioFilePath, `${material.name} - Audio.mp3`)}>
                      {material.name} - Audio
                    </span>
                  </div>
                )}
                <div className="material">
                  <FiFile size={20} />
                  <span onClick={() => downloadFile(material.pdfPath, `${material.name} - Worksheet.pdf`)}>
                    {material.name} - Worksheet
                  </span>
                </div>
              </div>
            )}
          </li>
        ))}
      </div>
      <div className="material-change-button">
        {page > 1 && <button onClick={() => handlePageChange("previous")}>Previous</button>}
        {page < Math.ceil(materials.length / itemsPerPage) && (
          <button onClick={() => handlePageChange("next")}>Next</button>
        )}
      </div>
    </div>
  )
}

export default ListeningMaterials

